export default [{
  "login_label": "Accedi",
  "back_label": "Indietro",
  "login_message": "Accedi al tuo account",
  "homepage_subtitle": "Accedi al tuo account",
  "homepage_title": "Benvenuto in Workhera",
  "credentialsLoginMessage_label": "Log in tramite email",
  "ssoAuthMessage_label": "Accedi con credenziali aziendali",
  "credentialsLogin_label": "Login",
  "ssoAuth_label": "SSO",
  "emailBox_label": "Email",
  "password_label": "Password",
  "ssoLogin_title": "Accedi con credenziali aziendali",
  "ssoLogin_subtitle": "Inserisci l'email aziendale",
  "ssoLogin_label": "SSO",
  "login_error": "Credenziali errate!",
  "missing_user_error": 'Utente inesistente!',
  "account_locked_error": 'Utente bloccato temporaneamente. Troppi tentativi di login falliti!',
  "access_not_enabled": "Accesso non abilitato",
  "sso_login_error": "Esegui il login con le credenziali aziendali!",
  "generic_error": "ops! si è verificato un problema.",
  "lineseparator": "Oppure",
  "teamsDoLogin_label": "Clicca per entrare",
  "teamsWaiting_message": "In attesa del processo di login nella popup",

  "forgotPsw_title": "Ripristino password",
  "forgotPsw_subtitle": "Inserisci la tua e-mail. Ti verrà inviata una mail con tutte le istruzioni per ripristinare la password.",
  "forgotPsw_restore": "Ripristina",
  "login_forgottenPassword": "Hai dimenticato la password? Clicca qui!",
  "forgotPsw_mail_error": "Mail non valida",
  "forgotPsw_SSO_error": "E' richiesto un reset della password SSO",
  "forgotPsw_generic_error": "Qualcosa è andato storto",
  "forgotPsw_success": "Richiesta effettuata! La mail arriverà a breve"
}]
